export function not_found({compId,shapeHeight,animationSpeed,flipAnimation}) {
  return `
  <pattern class="patternSingle" id="single_${compId}" patternUnits="userSpaceOnUse" viewbox="0 0 1920 240" x="50%" y="0" height="${shapeHeight}" width="1920" preserveAspectRatio="xMidYMax meet" patternTransform="translate(0 0)">
  <path fill="#6E6E6E" d="M960,37.5c-45.5,0-82.5,37-82.5,82.5s37,82.5,82.5,82.5s82.5-37,82.5-82.5S1005.5,37.5,960,37.5z M960,172.5
  	c-28.9,0-52.5-23.6-52.5-52.5s23.6-52.5,52.5-52.5c28.9,0,52.5,23.6,52.5,52.5S988.9,172.5,960,172.5z"/>
  <path fill="#B4B4B4" d="M960,65c-30.3,0-55,24.7-55,55s24.7,55,55,55s55-24.7,55-55S990.3,65,960,65z M960,145c-13.8,0-25-11.2-25-25
  	s11.2-25,25-25c13.8,0,25,11.2,25,25S973.8,145,960,145z"/>
  <circle fill="#303030" cx="960" cy="120" r="27.5"/>
  <path fill="#ffffff" d="M1091.6,240l-39.2-60.4c11.1-17.2,17.6-37.7,17.6-59.6c0-60.7-49.3-110-110-110S850,59.3,850,120c0,22,6.5,42.4,17.6,59.6
  	L828.4,240h26.2l27.5-42.4c17.5,17.6,40.9,29.2,66.9,31.8V240h22v-10.5c26-2.6,49.4-14.3,66.9-31.8l27.5,42.4H1091.6z M960,200
  	c-44.1,0-80-35.9-80-80s35.9-80,80-80c44.1,0,80,35.9,80,80S1004.1,200,960,200z"/>
  <path fill="#B4B4B4" d="M896,83.1h-13.9H873h-7.9l-41.7,65.7v19.2h49.1v16.9H896v-16.9h12.2v-19.4H896V83.1z M847.8,147.8l24.4-38.6
  	h0.8v39.4h-25.2V147.8z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="-90 240;0 0;0 0;0 240;0 240"
      keyTimes="0;0.025;0.7;0.8;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1"
      calcMode="spline"  dur="${3 * animationSpeed}s"
    repeatCount="indefinite" />
    <animateTransform attributeType="xml" attributeName="transform" type="skewX"
    values="-40;-20;10;-5;2;0;0;0;0"
    keyTimes="0;0.025;0.05;0.075;0.1;0.125;0.7;0.725;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1"
    calcMode="spline"  dur="${3 * animationSpeed}s"
    repeatCount="indefinite" additive="sum" />
  </path>
  <path transform="translate(-90 240)" fill="#B4B4B4" d="M1078.6,184.8h-12.2v-65.5h-13.9h-9.1h-7.9L993.8,185v19.2h49.1v16.9h23.5v-16.9h12.2V184.8z M1018.3,184
  	l24.4-38.6h0.8v39.4h-25.2V184z">
  <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="-90 240;0 0;0 0;0 240;0 240"
      keyTimes="0;0.025;0.7;0.8;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1"
      calcMode="spline" begin="0.5s" dur="${3 * animationSpeed}s"
    repeatCount="indefinite" />
    <animateTransform attributeType="xml" attributeName="transform" type="skewX"
    values="-40;-20;10;-5;2;0;0;0;0"
    keyTimes="0;0.025;0.05;0.075;0.1;0.125;0.7;0.725;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1"
    calcMode="spline" begin="0.5s" dur="${3 * animationSpeed}s"
    repeatCount="indefinite" additive="sum" />
  </path>
</pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}
